module.exports = __webpack_public_path__ + "static/media/empty.8d8cde2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assests/empty.png
// module id = 223
// module chunks = 0